import { OrderArticleTrackingDefectType } from '../../../lib-shared/types/OrderArticleTrackingDefectType';

export const OrderArticleTrackingDefectTypeMap = new Map([
  [OrderArticleTrackingDefectType.CLIENT_STAIN, 'Tâche client'],
  [OrderArticleTrackingDefectType.PROCESS_STAIN, 'Tâche machine'],
  [OrderArticleTrackingDefectType.TEAR, 'Déchirure'],
  [OrderArticleTrackingDefectType.BURN, 'Brûlure'],
  [OrderArticleTrackingDefectType.CREASE_DEFECT, 'Faux plis'],
  [OrderArticleTrackingDefectType.IMPROPER_FOLDING, 'Mauvais pliage'],
  [OrderArticleTrackingDefectType.MISSING_LABEL, 'Étiquette manquante'],
  [OrderArticleTrackingDefectType.UNREADABLE_LABEL, 'Étiquette illisible'],
  [OrderArticleTrackingDefectType.TORN_BLUE_BAG, 'Sac bleu déchiré'],
  [OrderArticleTrackingDefectType.COLOR_BLEEDING, 'Dégorgement'],
  [OrderArticleTrackingDefectType.POOR_IRONING, 'Mauvais repassage'],
  [OrderArticleTrackingDefectType.DAMP_ARTICLE, 'Article humide'],
  [OrderArticleTrackingDefectType.BILLING_ERROR, 'Erreur de facturation'],
  [OrderArticleTrackingDefectType.SHRINKAGE, 'Rétrécissement'],
  [OrderArticleTrackingDefectType.MISSING_DAMAGED_ACCESSORY, 'Accessoire manquant, endommagé'],
  [OrderArticleTrackingDefectType.SENSITIVE_ARTICLE, 'Article sensible avec accord client'],
]);
